"use strict";

import angular from "angular";

export class ChartHelper {
    constructor($filter, $rootScope, $scope, $timeout) {
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;

        this.reflow = false;
        this.listeners = [];
    }

    /**
     * @public
     * Format the value by the unit
     * @param {String} unit Unit to format
     * @param {Number} value Value unformatted
     * @return {Number} Value formatted
     */
    formatValue = (unit = "currency", value, fixed = true) => {
        const numbersFormat = {
            number: this.$filter("number")(value, 2),
            day: this.$filter("number")(value, 0),
            int: this.$filter("number")(value, 0),
            currency: this.$filter("currency")(value),
            percentage: `${this.$filter("formatPorcentagem")(
                fixed ? value.toFixed(2) : value.toFixed(0)
            )}%`
        };

        return numbersFormat[unit];
    };

    /**
     * @public
     * Generate an unique id for the chart
     */
    generateId = (id) => {
        return `${id}_${Date.now()}`;
    };

    /**
     * @public
     * Define the color of polarity
     *
     * @param {Object} serie
     * @param {Boolean}
     * @param {String} direction [Queda, Aumento]
     */
    polarityColor = (data, dot = true, direction) => {
        if (!data) return !dot ? "basic-medium" : "basic.medium";

        let color = "purple.medium";

        if (direction) {
            if (
                (direction == "Queda" && data.polarity == 1) ||
                (direction == "Aumento" && data.polarity == -1)
            ) {
                color = "purple.medium";
            } else {
                color = "cyan.medium";
            }
        } else {
            if (
                (data.current > data.prev && data.polarity == 1) ||
                (data.current < data.prev && data.polarity == -1)
            ) {
                color = "cyan.medium";
            }

            if (data.polarity == 0 || data.value == 0) color = "basic.medium";
        }

        return !dot ? color.replace(/[.]/g, "-") : color;
    };

    /**
     * @public
     * Define the color of polarity
     * @param {Number} polarity Polarity of chart
     * @return {Number} comparate Result of comparate of the chart date
     */
    _polarityColor = (polarity, comparate) => {
        if (polarity == 0) return "basic.darker";

        return polarity == comparate ? "cyan.medium" : "purple.medium";
    };

    /**
     * Reflow all the active charts
     * @public
     * @param {Number} wait Time to wait before
     */
    chartsReflow = (wait) => {
        const runningTimeOut = this.$timeout(
            () => this.$rootScope.$broadcast("triggerReflow"),
            wait
        );
        this.$scope.$on("$destroy", () => this.$timeout.cancel(runningTimeOut));
    };
}

angular
    .module("nucont.shared")
    .service("ChartHelper", [
        "$filter",
        "$rootScope",
        "$scope",
        "$timeout",
        ChartHelper
    ]);
